import https from '@/http/httprequest'

export const getHistory= () =>{
  return https.fetchGet('/v1/home/common/history')
}
/**
 * 
 * @param {*} type 
 * @param {*} pageSize 
 * @param {*} pageNum 
 * @returns 
 */

export const getConsultingService = (type,pageSize,pageNum)=>{
    return https.fetchGet(`/v1/home/article/load/${type}?pageSize=${pageSize}&pageNum=${pageNum}`)
}
export const getHome = () => {
  return https.fetchGet(`/v1/home/home/`)
}
export const getFazhan = () => {
  return https.fetchGet(`/v1/home/developmentHistory/listAll`)
}
export const getWenhua = () => {
  return https.fetchGet(`/v1/home/corporateCulture/load`)
}
export const getImgList = (type) =>{
  return https.fetchGet(`v1/home/project/loadProject?type=${type}`)
}

export const getDetils = (id) =>{
  return https.fetchGet(`/v1/home/article/loadOne?id=${id}`)
}
export const getAllproject = ()=>{
  return https.fetchGet(`v1/home/project/loadAllProject`)
}

export const getindeximg = () =>{
  return https.fetchGet(`/v1/home/article/homeArticle`)
}
export const getZizhiData=(type)=>{
  return https.fetchGet(`v1/home/qualifications/loadTypeList?type=${type}`)
} 
export const getZoxunList =(type) =>{
  return https.fetchGet(`/v1/home/article/load/${type}`)
}


// WEBPACK FOOTER //
// ./src/api/index.js